import store from '../store'
import { Auth } from 'aws-amplify';

// Lazy load router to avoid circular dependencies.
// Must resolve the ACTIVE app's router: this module is shared by the trader,
// broker and IB apps, and pushing the 401 redirect on the trader router while
// the IB/broker app is mounted only rewrites the address bar on a detached
// router instance instead of navigating the user to login (SFB-1243).
let router = null;
const getRouter = () => {
    if (!router) {
        if (process.env.VUE_APP_IB_STANDALONE === 'true') {
            router = require('../apps/ib/router').default;
        } else if (process.env.VUE_APP_BROKER_STANDALONE === 'true') {
            router = require('../apps/broker/router').default;
        } else {
            router = require('../router').default;
        }
    }
    return router;
};

function verifyAuth(response) {
    let exceptedRoutesByName = ["connectmt", "connectexness","funding-simulation-summary","funding-simulation-feedback","tournament-overview","tournament-embed-rank","register","integrations","platform-setup","tournament-embed-register"];
    response.catch(async (error) => {
        if (error.response && error.response.status === 401) {
            const currentRouter = getRouter();
            if (currentRouter && !exceptedRoutesByName.includes(currentRouter.currentRoute.name)) {
                try {
                    let currentSession = await Auth.currentSession()
                    store.commit('setToken', `Bearer ${currentSession.idToken.jwtToken}`)
                    currentRouter.push('/dashboard')
                } catch (err) {
                    /* eslint-disable no-console */
                    console.error(err);
                    /* eslint-enable no-console */
                    if (store.state.whitelabel.partner) {
                        store.commit('setToken', '') // Ensure embed will force the user to login again using magic link
                        currentRouter.push({
                            path: '/embed',
                            query: {
                                embedKey: store.state.whitelabel.apiKey,
                                userId: store.state.whitelabel.userId,
                                userEmail: store.state.whitelabel.userEmail,
                                context: store.state.whitelabel.context
                            }
                        })
                    } else {
                        store.commit('clearData');
                        currentRouter.push('/'); // Go to login to re-authenticate´

                    }
                }
            }
        }
    });
    return response
}

export default verifyAuth